import styled from 'styled-components';

export const RegisterFormContainer = styled.form`
  button[type="submit"] {
    width: 100%;
  }

  label {
    font-weight: 600;
    font-size: 12px;
  }

  .submit-link {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: ${props => props.theme.colors.primary};
    padding: 8px 0;
    color: #fff;
    border-radius: 6px;
    margin-top: 32px;
  }
`;

export const RegisterRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;

  input {
    margin-bottom: 12px;
  }

  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
  }
`;

export const PhoneRow = styled.div`
  display: grid;
  grid-template-columns: 20% 1fr;
  grid-gap: 12px;
`;
